(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-contact"] && !Shopify.designMode) return;
  try {
    
function initSTAGContact() {
 const interest = new URLSearchParams(window.location.search).get('interest');
 const select = document.getElementById('sr-interest');
 if(select && ['custom','wallet','woodworking','beta','updates','other'].includes(interest)) select.value = interest;
 const project = document.getElementById('sr-project-details');
 const updateProject = () => { if(!project || !select) return; const shown=['custom','wallet','woodworking'].includes(select.value); project.hidden=!shown; project.querySelectorAll('input').forEach(input=>input.disabled=!shown); };
 if(select && !select.dataset.bound) { select.dataset.bound='true'; select.addEventListener('change',updateProject); } updateProject();
 const button = document.getElementById('sr-save-contact');
 if(button && !button.dataset.bound) { button.dataset.bound='true'; button.addEventListener('click',function(){
   const escapeV = value => value.replace(/\\/g,'\\\\').replace(/\n/g,'\\n').replace(/[,;]/g,'\\$&');
   const card=['BEGIN:VCARD','VERSION:3.0','FN:'+escapeV(button.dataset.name),'N:Gardner;Mikale;;;','ORG:STAG Tactical Group','EMAIL:'+escapeV(button.dataset.email),'TEL;TYPE=WORK:'+escapeV(button.dataset.phone),'URL:https://stagtacticalgroup.com','END:VCARD'].join('\r\n');
   const url=URL.createObjectURL(new Blob([card],{type:'text/vcard;charset=utf-8'})); const link=document.createElement('a');link.href=url;link.download='Mikale-Gardner-STAG.vcf';link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
 }); }
}
initSTAGContact();document.addEventListener('shopify:section:load',initSTAGContact);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const menu = document.querySelector('.sr-mobile-menu');
  if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.removeAttribute('open');
});
document.addEventListener('keydown', function(event) {
  if(event.key === 'Escape') {
    const menu = document.querySelector('.sr-mobile-menu[open]');
    if(menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  }
});

  } catch(e) { console.error(e); }
})();
})();
